import { Settings, Bell, Lock, Globe } from 'lucide-react'

const SettingsPage = () => {
    return (
        <div className="p-6">
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-900">Configurações</h1>
                <p className="text-gray-600 mt-1">Gerencie as configurações do sistema</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Geral */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow cursor-pointer">
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600 mb-4">
                        <Settings className="w-6 h-6" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Geral</h3>
                    <p className="text-gray-500 text-sm">Informações básicas do sistema e preferências globais.</p>
                </div>

                {/* Notificações */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow cursor-pointer">
                    <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center text-yellow-600 mb-4">
                        <Bell className="w-6 h-6" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Notificações</h3>
                    <p className="text-gray-500 text-sm">Gerencie modelos de e-mail e configurações de alerta.</p>
                </div>

                {/* Segurança */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow cursor-pointer">
                    <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center text-green-600 mb-4">
                        <Lock className="w-6 h-6" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Segurança</h3>
                    <p className="text-gray-500 text-sm">Logs de acesso, permissões e políticas de senha.</p>
                </div>

                {/* Site Público */}
                <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow cursor-pointer">
                    <div className="w-10 h-10 bg-purple-100 rounded-lg flex items-center justify-center text-purple-600 mb-4">
                        <Globe className="w-6 h-6" />
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2">Site Público</h3>
                    <p className="text-gray-500 text-sm">Configure banners, contatos e SEO do site principal.</p>
                </div>
            </div>
        </div>
    )
}

export default SettingsPage
